import type { ComponentPropsWithoutRef } from 'react';
import { align, direction, gap, justify, stack, wrap } from './Stack.css';

type Direction = keyof typeof direction;
type Align = keyof typeof align;
type Justify = keyof typeof justify;
type Gap = keyof typeof gap;

export type StackProps = ComponentPropsWithoutRef<'div'> & {
  direction?: Direction;
  align?: Align;
  justify?: Justify;
  gap?: Gap;
  wrap?: boolean;
};

export function Stack({
  direction: d = 'column',
  align: a = 'stretch',
  justify: j = 'start',
  gap: g = 'md',
  wrap: doWrap = false,
  className,
  ...rest
}: StackProps) {
  const classes = [
    stack,
    direction[d],
    align[a],
    justify[j],
    gap[g],
    doWrap ? wrap : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={classes} {...rest} />;
}
